import SubrubProfileSearchForm from '@components/SuburbProfileSearchForm'
import Hero from '@global/Blocks/Hero'
import Text from '@global/Blocks/Text'
import TwinEqualCTA from '@global/Blocks/TwinEqualCTA'
import WagtailBlocksSection from '@global/Blocks/WagtailBlocksSection'
import Breadcrumbs from '@global/Breadcrumbs'
import { getCanonicalURL } from '@lib/api'
import { defaultImages } from '@lib/variables'
import { Section } from '@styles/global.styled'
import { NextSeo } from 'next-seo'

const LocalInformationLanding = (props) => {
  const {
    pageData: {
      meta,
      headline_text,
      intro_text,
      content_blocks,
      hero_image,
      region_pages,
      text,
    },
  } = props

  const centeredImageAndTextBlocks = content_blocks?.filter(
    (it) => it.type === 'centered_image_and_text'
  )
  const resBlocks = content_blocks?.filter(
    (it) => it.type !== 'centered_image_and_text'
  )

  const defaultTitle =
    'Suburb Profiles & Property Market Data | Search Every Suburb'
  const defaultDescription =
    'Your ultimate resource for suburb profiles. Search and explore detailed real estate data, from up-to-date median prices and sales trends to rental yields and local insights for every suburb and municipality.'
  const canonicalURL = getCanonicalURL({ canonical: meta?.canonical, path: meta?.path })
  const metaTitle = meta.meta_title || defaultTitle
  const metaDescription = meta.meta_description || defaultDescription || ''
  const ogTitle = meta.og_title || metaTitle
  const ogImage = meta.og_img
    ? [{ url: meta.og_img }]
    : hero_image
    ? [{ url: hero_image.url }]
    : [{ url: defaultImages.mediumNavy }]
  const ogDescription = meta.og_description || metaDescription

  return (
    <>
      <NextSeo
        title={metaTitle}
        description={metaDescription}
        canonical={canonicalURL}
        openGraph={{
          images: ogImage,
          title: ogTitle,
          description: ogDescription,
          url: canonicalURL,
          type: 'website',
        }}
      />

      <Hero
        breadcrumbs={
          <Breadcrumbs
            secondary
            breadcrumbs={meta.breadcrumbs?.map((it) => ({
              ...it,
              label: it.title,
            }))}
          />
        }
        title={headline_text}
        bgImageUrl={hero_image?.url}
        description={intro_text}
        withAppraisalButton
        searchForm={<SubrubProfileSearchForm />}
      />

      {!!text && (
        <Section>
          <Text content={text} />
        </Section>
      )}

      <WagtailBlocksSection blocks={centeredImageAndTextBlocks} />
      {region_pages?.length > 0 && (
        <Section withPaddingBottom={!(content_blocks?.length > 0)}>
          <TwinEqualCTA
            title='Browse suburbs by municipality'
            bgColor='white'
            roundedItem
            itemsLimit={12}
            numberOfItems={3}
            loadMoreText='Load More'
            size='sm'
            items={
              region_pages.map((item) => {
                return {
                  title: item.name,
                  image: item.image,
                  url: item.url,
                }
              }) ?? []
            }
          />
        </Section>
      )}
      <WagtailBlocksSection blocks={resBlocks} />
    </>
  )
}

export default LocalInformationLanding
